export default __webpack_public_path__ + "static/media/zingPcv2@2x.16bb3cb6.png";